import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

import { SET_LIST} from 'vx/mutations'

const state = {
  items: []
}

const getters = {
  items: state => state.items,
}

const actions = {

  /**
   * Get a list of items.
   */
  getItems ({ commit }, id, payload) {
    return http.get(`/sla/types`).then(response => {
      commit(SET_LIST, response.data)
      return response
    })
  },
}

const mutations = {
  
  [SET_LIST] (state, items) {
    state.items = items
  }
}

export default {
  namespaced: true, state, getters, actions, mutations
}
